module.exports = __webpack_public_path__ + "static/img/49634bcd4b29f89f792a19b5ea191efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_01.png
// module id = Q0fz
// module chunks = 1